import { atom } from "recoil";

export const currentManagerTableHeight = atom({
  key: "currentManagerTableHeight", // unique ID (with respect to other atoms/selectors)
  default: -1, // default value (aka initial value)
});
